import { useEffect, useRef } from "react";
import ringSound from "../../../Assets/whatsapp_notification_orignal.mp3";
import { useNotificationContext } from "../NotificationContext";

export function useWhatsappNotifications(wsUrl, formatMessage) {
  const audioRef = useRef(null);
  const { addNotification } = useNotificationContext();

  useEffect(() => {
    if (!wsUrl) return;

    const audio = new Audio(ringSound);
    audioRef.current = audio;
    audio.preload = "auto";

    if (Notification.permission !== "granted") {
      Notification.requestPermission();
    }

    const ws = new WebSocket(wsUrl);

    ws.onopen = () => console.log("WebSocket connected:", wsUrl);

    ws.onmessage = (event) => {
      try {
        const rawData = JSON.parse(event.data);
        const data = formatMessage(rawData);
        if (!data) return;

        const isTabActive = document.visibilityState === "visible";

        const newNotification = {
          id: Date.now(),
          ...data,
        };

        if (isTabActive) {
          addNotification(newNotification);
          audioRef.current?.play().catch(() => {
            /* ignore play errors */
          });
        } else if (Notification.permission === "granted") {
          const browserNotification = new Notification(
            `🔔 ${data?.type || "Message"}`,
            {
              body: data.message || "New message received",
              icon: "/favicon.ico",
            },
          );
          browserNotification.onclick = () => window.focus();
        }
      } catch (e) {
        console.error("Failed to handle WebSocket message", e);
      }
    };

    ws.onclose = () => console.log("WebSocket disconnected:", wsUrl);

    return () => {
      if (
        ws.readyState === WebSocket.OPEN ||
        ws.readyState === WebSocket.CONNECTING
      ) {
        ws.close();
      }
      audioRef.current = null;
    };
  }, [wsUrl, formatMessage, addNotification]);
}
